<section [formGroup]="formGroup">
  @let formGroupAlertShouldBeVisible = submitted && formGroup.invalid;
  <section>
    <div
      class="card"
      [ngClass]="formGroupAlertShouldBeVisible ? 'border-danger border-2' : ''"
    >
      <div class="card-header">
        {{ sectionHeader | translate }}
      </div>

      <div class="card-body">
        <div class="row">
          <div class="col-lg col-md-12">
            <label class="mb-0" [attr.for]="controlName.Scope">
              {{ 'MONUMENT_CONSERVATION_GRANT_REQUEST.SCOPE' | translate }}
            </label>

            <input
              type="text"
              [name]="controlName.Scope"
              [id]="controlName.Scope"
              class="form-control form-control-sm required"
              [formControlName]="controlName.Scope"
            />
          </div>
          <div class="col-lg col-md-12">
            <label class="mb-0" [attr.for]="controlName.Amount">
              {{ 'MONUMENT_CONSERVATION_GRANT_REQUEST.AMOUNT' | translate }}
            </label>

            <input
              type="number"
              [name]="controlName.Amount"
              [id]="controlName.Amount"
              class="form-control form-control-sm required"
              [formControlName]="controlName.Amount"
              (keypress)="validateFloatInput($event)"
            />
          </div>
          <div class="col-lg col-md-12">
            <label class="mb-0" [attr.for]="controlName.PercentageShare">
              {{
                'MONUMENT_CONSERVATION_GRANT_REQUEST.PERCENTAGE_SHARE'
                  | translate
              }}
            </label>

            <div class="input-group input-group-sm">
              <input
                type="text"
                [name]="controlName.PercentageShare"
                [id]="controlName.PercentageShare"
                class="form-control required"
                [formControlName]="controlName.PercentageShare"
                (keypress)="validateFloatInput($event)"
              />
              <span class="input-group-text">%</span>
            </div>
          </div>
        </div>
      </div>

      @if (formGroupAlertShouldBeVisible) {
        <div class="card-footer">
          <div class="alert alert-danger my-2">
            {{ 'FIELDS_REQUIRED' | translate }}
          </div>
        </div>
      }
    </div>
  </section>
</section>
